const Stavba = () => {
  return (
    <div>Stavba</div>
  )
}

export default Stavba